import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfilesTable } from '../../../common/profiles-list/ProfilesTable';

type SupplierTableProps = React.PropsWithChildren<{
  isEmpty: boolean;
}>;

export const SuppliersTable: React.FC<SupplierTableProps> = ({ isEmpty, children }) => {
  const { t } = useTranslation();
  return (
    <ProfilesTable
      ariaLabel={t('supplierProfiles.header')}
      isEmpty={isEmpty}
      emptyMessage={t('messages.emptySuppliersMessage')}
    >
      {children}
    </ProfilesTable>
  );
};
